class Home {
  constructor() {
    const body = document.querySelector('body');
    if (body.classList.contains('home') && window.scrollY < window.innerHeight) {
      let first = true;
      window.addEventListener('scroll', () => {
        if (first && window.location.hash == '') {
          first = false;
          window.scrollTo({
            top: window.innerHeight,
            left: 0,
            behavior: 'smooth'
          });
        }
      });
    }
  }
}

export default Home;
